<template>
  <component :is="currentComponent"/>
</template>

<script>
import Mixin from '@/components/mixin/common_mixin';
import ymsIndex from "@/views/shopping/index/components/ymsIndex.vue";
import trsIndex from "@/views/shopping/index/components/trsIndex.vue";

export default {
  name: 'index',
  mixins: [Mixin],
  components: {
    ymsIndex,
    trsIndex
  },
  computed: {
    currentComponent() {
      return this.systemEnvironment === 'trs' ? 'trsIndex' : 'ymsIndex';
    }
  }
};
</script>

<style lang="less">
</style>